import { Amplify } from "aws-amplify";
import { getAppData } from "app/getAppData";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const { authUrl, clientId, userPoolId } = await getAppData();

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: authUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId,
        userPoolClientId: clientId,
      },
    },
  });

  isConfigured = true;
};
